const banks = [
	{
		name: 'Dragsholm Sparekasse',
	},
	{
		name: 'Faster/Oikos Andelskasse',
	},
	{
		name: 'Frørup Andelskasse',
	},
	{
		name: 'Nordfyns Bank',
	},
	{
		name: 'Hvidbjerg Bank',
	},
	{
		name: 'Ringkjøbing Landbobank',
	},
	{
		name: 'Nordjyske Bank',
	},
	{
		name: 'Vestjysk Bank',
	},
	{
		name: 'Skjern Bank',
	},
	{
		name: 'Kreditbanken',
	},
	{
		name: 'Nykredit',
	},
	{
		name: 'Andelskassen Fælleskassen',
	},
	{
		name: 'Fynske Bank',
	},
	{
		name: 'Rise Sparekasse',
	},
	{
		name: 'Sparekassen Thy',
	},
	{
		name: 'Klim Sparekasse',
	},
	{
		name: 'Sparekassen Balling',
	},
	{
		name: 'Sparekassen Kronjylland',
	},
	{
		name: 'Rønde Sparekasse',
	},
	{
		name: 'Spar Nord Bank',
	},
	{
		name: 'Sparekassen for Nr. Nebel & Om',
	},
	{
		name: 'Sydjysk Sparekasse',
	},
	{
		name: 'PrivatSikring',
	},
	{
		name: 'Arbejdernes Landsbank',
	},
	{
		name: 'Sparekassen Bredebro',
	},
	{
		name: 'Merkur Andelskasse',
	},
];

export default banks;
